    // FORMAT DATA
    const formatDate = (item) => {
      let result;
      let time;
      let data;
      let day;
      let month;
      let year;
      data = item.substring(0,10);
      time = item.substring(11,16);
      day = data.substring(8,10); 
      month = data.substring(5,7);   
      year = data.substring(0,4);  

      result = `${time} ${day}/${month}/${year}`;
        return result;
        //return data;
    }
    export {formatDate};